import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgDeliveroo = function SvgDeliveroo(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_g || (_g = /*#__PURE__*/_jsx("g", {
      clipPath: "url(#deliveroo_svg__a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.48-.48H-.48v35.96h35.96V-.48ZM21.363 7.999a.025.025 0 0 1 .027-.022l4.818.501a.025.025 0 0 1 .023.028L24.917 20.87a.025.025 0 0 1-.003.007l-2.766 6.13a.025.025 0 0 1-.027.015L10.01 24.467a.025.025 0 0 1-.02-.02l-1.217-5.605a.025.025 0 0 1 .02-.03l6.845-1.438a.025.025 0 0 0 .02-.03l-1.495-7.03a.025.025 0 0 1 .02-.029l4.744-.987a.025.025 0 0 1 .03.019l1.482 6.901c.006.028.047.026.05-.002l.873-8.217Zm-5.054 11.487c0 .437.357.793.794.793a.795.795 0 0 0 .794-.793.795.795 0 0 0-.794-.794.795.795 0 0 0-.794.794Zm3.175 1.587c0 .437.357.794.794.794a.795.795 0 0 0 .794-.794.795.795 0 0 0-.794-.794.795.795 0 0 0-.794.794Z",
        fill: "currentColor"
      })
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "deliveroo_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h35v35H0z"
        })
      })
    }))]
  }));
};
export default SvgDeliveroo;